import { render, staticRenderFns } from "./pos-articles-checkout.vue?vue&type=template&id=ffb92496&scoped=true&"
import script from "./pos-articles-checkout.ts?vue&type=script&lang=ts&"
export * from "./pos-articles-checkout.ts?vue&type=script&lang=ts&"
import style0 from "./pos-articles-checkout.scss?vue&type=style&index=0&id=ffb92496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb92496",
  null
  
)

export default component.exports